import React, { useState } from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Slider from "react-slick";
import TitleSection from "../title-section";

import "./videoCarrusel.scss"
import "../number-steps/numberSteps.scss"

const VideoCarrusel = ({tituloGeneral, referenciaPlantillaContenido, contentful_id} : ReferenciaContenido) => {
    const CarouselProps = {
        dots: contentful_id != "6Lg4wRn1QABIHYq4ZV0Szq",
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        responsive: [
            {
                breakpoint: 1330,
                settings: {
                    slidesToShow: 2.2,
                    dots:true,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1.2,
                    dots:true,
                    slidesToScroll: 1
                }
            }
          ]
    };
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [selectedVideo, setSelectedVideo] = useState<string>("");

    const renderVideoCards = () => referenciaPlantillaContenido.map((item, index) => 
        <div key={`video-card-${index}`} className="m-video-carrusel__card" >
            <iframe 
                src={item.redireccionBoton}
                allow="picture-in-picture; controls"
                width={window.innerWidth <= 768 ? "318" : "384"}
                height={window.innerWidth <= 768 ? "175" : "215"}
                className="m-video-carrusel__frame"
            />
            <button
                className="m-video-carrusel__frame-button" 
                onClick={() => {
                    setIsOpenModal(true);
                    setSelectedVideo(item.redireccionBoton);
                }}>
                    Reproducir
            </button>
            {documentToReactComponents(item.descripcion.json)}
        </div>
    )
    
    return (
        <>
            <section className="m-video-carrusel">
                <TitleSection title={tituloGeneral} />
                    <div className="m-video-carrusel__slider-container">
                        <Slider {...CarouselProps}> 
                            {renderVideoCards()}
                        </Slider>
                    </div>
            </section>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <span className="icon-close" onClick={() => setIsOpenModal(false)}></span>
                    <div className="m-number-steps__modal-content">
                        <iframe
                            src={selectedVideo}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                        </iframe>  
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoCarrusel;